export const touch_handler = (node) => {
	const prevent_rest = (event, condition) => {
		if (node && node.contains(event.target)) {
			node.dispatchEvent(new CustomEvent(condition, node));
		}
	};

	const events = ['touchstart', 'mousedown', 'mouseup', 'touchend', 'mouseleave'];

	events.forEach((event) => {
		node.addEventListener(event, prevent_rest(event, event), { passive: true });
	});

	return {
		destroy(e) {
			//On destroy event removes event listeners. If you want you can uncomment this log and you will see
			//that this log in console DESTROYED as many times as buttons are available on page
			// console.warn('DESTROYED')
			events.forEach((event) => node.removeEventListener(event, e));
		},
	};
};

// /** Dispatch event on longpress */
// export function longpress(node, threshold = 500) {
// 	const handle_mousedown = () => {
// 		let start = Date.now();

// 		const timeout = setTimeout(() => {
// 			node.dispatchEvent(new CustomEvent('longpress', node));
// 		}, threshold);

// 		const cancel = () => {
// 			clearTimeout(timeout);
// 			node.removeEventListener('mousemove', cancel);
// 			node.removeEventListener('touchmove', cancel);
// 			node.removeEventListener('mouseup', cancel);
// 			node.removeEventListener('touchend', cancel);
// 		};

// 		node.addEventListener('mousemove', cancel, { passive: true });
// 		node.removeEventListener('touchmove', cancel);
// 		node.addEventListener('mouseup', cancel, { passive: true });
// 		node.removeEventListener('touchend', cancel);
// 	};

// 	node.addEventListener('mousedown', handle_mousedown, { passive: true });
// 	node.addEventListener('touchstart', handle_mousedown, { passive: true });

// 	return {
// 		destroy() {
// 			node.removeEventListener('mousedown', handle_mousedown);
// 			node.addEventListener('touchstart', handle_mousedown, { passive: true });
// 		}
// 	};
// }

/** Dispatch event on click outside of node */
export function click_outside(node, useCapture = false) {
	const handleClick = (event) => {
		if (node && !node.contains(event.target) && !event.defaultPrevented) {
			node.dispatchEvent(new CustomEvent('click_outside', node));
		}
	};
	document.addEventListener('click', handleClick, useCapture);
	return {
		destroy() {
			document.removeEventListener('click', handleClick, useCapture);
		},
	};
}

export function hold_off_click(node, delay = 2200) {
	let timer;

	const handle_single_click = (event) => {
		clearTimeout(timer);
		timer = 0;
		/*** the IF stops events from other nodes that use this action,
		 * the same as touch_handler do this
		 */
		if (node && node.contains(event.target)) {
			timer = setTimeout(() => {
				node.dispatchEvent(new CustomEvent('hold_off_click_end', node));
			}, delay);
		}
	};

	document.addEventListener('click', handle_single_click, true);

	return {
		destroy() {
			document.removeEventListener('click', handle_single_click, true);
		},
	};
}
